import { useState, useCallback } from 'react';
import { scApi, FC110, FC111 } from '../../../services/scApi';

export function useLookupNames() {
  const [names, setNames] = useState<Record<string, string>>({});

  /** Batch-resolve all lookup names for master + selected detail row */
  const resolveAllNames = useCallback(async (data: Partial<FC110>, detail?: Partial<FC111>) => {
    const entries: [string, string, string][] = [
      ['salesperson', 'employee', data.fc110_13 || ''],
      ['department', 'department', data.fc110_10 || ''],
      ['entryPerson', 'employee', data.fc110_18 || ''],
      ['customer', 'customer', data.fc110_12 || ''],
      ['garmentBuyer', 'customer', data.fc110_17 || ''],
      ['middleman', 'customer', data.fc110_16 || ''],
      ['currency', 'currency', data.fc110_24 || ''],
      ['paymentTerms', 'paymentTerms', data.fc110_22 || ''],
      ['perfCustomer', 'customer', data.fc110_59 || ''],
      ['remarkTemplate', 'remarkTemplate', data.fc110_271 || ''],
    ];
    if (detail) {
      entries.push(
        ['packing', 'packing', detail.fc111_30 || ''],
        ['tradeTerms', 'tradeTerms', detail.fc111_29 || ''],
        ['purchCurrency', 'currency', detail.fc111_41 || ''],
      );
    }
    const results = await Promise.all(
      entries.map(([key, type, code]) =>
        scApi.lookupName(type, code).then(name => [key, name] as [string, string])
      )
    );
    setNames(prev => {
      const next = { ...prev };
      for (const [key, name] of results) next[key] = name;
      return next;
    });
  }, []);

  /** Resolve a single lookup name (for onBlur events) */
  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    const name = await scApi.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  /** Clear all cached names */
  const clearNames = useCallback(() => {
    setNames({});
  }, []);

  return { names, setNames, resolveAllNames, resolveSingleName, clearNames };
}
